module.exports = __webpack_public_path__ + "static/email/img/email_tracker.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email_tracker.png
// module id = vLp5
// module chunks = 1